import { AcademicLevel, Accompagnateurs, Availabilities, CampaignId, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, PostalCode, Section, SlotId } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Accompagnateurs,
  ...Availabilities,
  ...CampaignId,
  ...Consentement,
  formations: Yup.array().min(1, 'Vous devez choisir au minimum une formation'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...PostalCode,
    ...Section
  }),
  ...SlotId
})

export default schema
